import MyManager from './sections/MyManager';
import Schedule from './sections/Schedule';
import MyProjects from './sections/MyProjects';
import MyPayments from './sections/MyPayments';
import MyRequisites from './sections/MyRequisites';
import SalaryCalculator from './sections/SalaryCalculator';
import UnderConstruction from './sections/UnderConstruction';
import { PROJECTS_LIST, SMM_PROJECTS_LIST } from '../../mocks/auth';
import type { CabinetConfig } from './types';

const STANDARD_RATES = { day: 380, night: 420, taxRate: 0.06, monthlyHoursLimit: 300 };

const OPERATOR_SECTIONS = [
  { id: 'manager',    title: 'Мой менеджер',   icon: 'ri-user-heart-line',   component: MyManager },
  { id: 'schedule',   title: 'Расписание',     icon: 'ri-calendar-line',     component: Schedule },
  { id: 'projects',   title: 'Мои проекты',    icon: 'ri-folder-open-line',  component: MyProjects },
  { id: 'payments',   title: 'Мои выплаты',    icon: 'ri-wallet-3-line',     component: MyPayments },
  { id: 'requisites', title: 'Мои реквизиты',  icon: 'ri-file-list-3-line',  component: MyRequisites, lockIcon: 'ri-lock-line' },
  { id: 'calculator', title: 'Калькулятор ЗП', icon: 'ri-calculator-line',   component: SalaryCalculator },
];

export const CHAT_OPERATOR_CABINET: CabinetConfig = {
  vacancyId: 'chat-operator',
  roleLabel: 'Оператор чата',
  defaultSection: 'manager',
  sections: OPERATOR_SECTIONS,
  projects: PROJECTS_LIST,
  rates: STANDARD_RATES,
  features: { meetingRequest: true },
  showOnboardingNotice: true,
};

/**
 * Тот же набор разделов, ставок и правил, что у оператора чата, — отличаются только
 * формулировки: роль в сайдбаре и описания направлений в «Моих проектах».
 */
export const SMM_MANAGER_CABINET: CabinetConfig = {
  vacancyId: 'smm-manager',
  roleLabel: 'Менеджер социальных сетей',
  defaultSection: 'manager',
  sections: OPERATOR_SECTIONS,
  projects: SMM_PROJECTS_LIST,
  rates: STANDARD_RATES,
  features: { meetingRequest: true },
  showOnboardingNotice: true,
};

/** Каркас: работает «Мой менеджер», остальное — заглушки. */
export const QUALITY_MANAGER_CABINET: CabinetConfig = {
  vacancyId: 'quality-manager',
  roleLabel: 'Менеджер оценки качества',
  defaultSection: 'manager',
  sections: [
    { id: 'manager',    title: 'Мой менеджер',    icon: 'ri-user-heart-line',  component: MyManager },
    { id: 'reviews',    title: 'Оценка диалогов', icon: 'ri-chat-check-line',  component: UnderConstruction },
    { id: 'reports',    title: 'Отчёты',          icon: 'ri-bar-chart-line',   component: UnderConstruction },
    { id: 'payments',   title: 'Мои выплаты',     icon: 'ri-wallet-3-line',    component: UnderConstruction },
    { id: 'requisites', title: 'Мои реквизиты',   icon: 'ri-file-list-3-line', component: UnderConstruction },
  ],
  rates: STANDARD_RATES,
  features: { meetingRequest: false },
  showOnboardingNotice: true,
};
